export class SendRawMessageActionSettings {
    static $inject = ['init'];
    constructor(init) {
        this.metadata = {};
        this.type = 'text/plain';
        Object.assign(this, init);
    }
}
